<template>
  <v-row>
    <v-col cols="12">
      <add-new-ip />
    </v-col>
    <v-col cols="12">
      <blocked-ip-table />
    </v-col>
  </v-row>
</template>

<script>
import BlockedIpTable from '@/components/Services/Hosting/Shared/Security/BlockedIp/BlockedIpTable'
import AddNewIp from 'Components/Services/Hosting/Shared/Security/BlockedIp/AddNewIp'

export default {
  name: 'BlockedIpView',
  components: {
    AddNewIp,
    BlockedIpTable
  },
}
</script>

<style scoped>

</style>
